import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c7d0700&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1c7d0700&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d0700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7d0700')) {
      api.createRecord('1c7d0700', component.options)
    } else {
      api.reload('1c7d0700', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c7d0700&scoped=true&lang=pug", function () {
      api.rerender('1c7d0700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/bookClass/index.vue"
export default component.exports